module.exports = __webpack_public_path__ + "static/sleeksupply-97a028daa31894e7c4be0746b0ef89e8.png";